export default __webpack_public_path__ + "static/media/no_notification.27c1ebd7.png";